"use strict";
exports.__esModule = true;
exports.ResizeTableCell = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var __1 = require("../..");
var ResizeTableCellStyles_1 = tslib_1.__importDefault(require("./ResizeTableCellStyles"));
var ResizeTableContext_1 = require("./ResizeTableContext");
var MIN_COLUMN_WIDTH = 100;
var ResizeTableCell = function (_a) {
    var _b, _c;
    var children = _a.children, columnId = _a.columnId, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onWidthChange = _a.onWidthChange, width = _a.width, _d = _a.minWidth, minWidth = _d === void 0 ? MIN_COLUMN_WIDTH : _d, style = _a.style, _e = _a.className, className = _e === void 0 ? '' : _e, restProps = tslib_1.__rest(_a, ["children", "columnId", "onDragStart", "onDragEnd", "onWidthChange", "width", "minWidth", "style", "className"]);
    var _f = react_1.useContext(ResizeTableContext_1.ResizeTableContext), draggingColumnId = _f.data.draggingColumnId, actions = _f.actions;
    var cellRef = react_1.useRef(null);
    var _g = react_1.useState(0), initialColumnX = _g[0], setInitialColumnX = _g[1];
    var _h = react_1.useState(0), columnX = _h[0], setColumnX = _h[1];
    var classes = ResizeTableCellStyles_1["default"]();
    var onMouseDown = function (event) {
        event.preventDefault();
        setInitialColumnX(event.pageX);
        setColumnX(event.pageX);
        actions.setDraggingColumnId(columnId);
        onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart();
        document.body.style.cursor = 'col-resize';
    };
    react_1.useEffect(function () {
        var onMouseMove = function (event) {
            setColumnX(event.pageX);
        };
        var onMouseUp = function (event) {
            if (cellRef.current) {
                setInitialColumnX(0);
                setColumnX(0);
                actions.setDraggingColumnId(null);
                onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd();
                document.body.style.cursor = 'unset';
                var columnX_1 = event.pageX;
                var value = columnX_1 - initialColumnX;
                var cellCoordinates = cellRef.current.getBoundingClientRect();
                if (cellCoordinates.left + minWidth >= columnX_1) {
                    value = cellCoordinates.left + minWidth - initialColumnX;
                }
                onWidthChange === null || onWidthChange === void 0 ? void 0 : onWidthChange(width + value);
            }
        };
        if (initialColumnX && draggingColumnId === columnId) {
            window.addEventListener('mousemove', onMouseMove);
            window.addEventListener('mouseup', onMouseUp);
        }
        return function () {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, [
        initialColumnX,
        draggingColumnId,
        columnId,
        actions,
        onDragStart,
        onDragEnd,
        onWidthChange,
        width,
        minWidth
    ]);
    var draggableStyle = {};
    if (initialColumnX && columnX) {
        var value = columnX - initialColumnX;
        if (cellRef.current) {
            var cellCoordinates = cellRef.current.getBoundingClientRect();
            if (cellCoordinates.left + minWidth >= columnX) {
                value = cellCoordinates.left + minWidth - initialColumnX;
            }
        }
        draggableStyle = {
            transform: "translate(" + value + "px)"
        };
    }
    return (react_1["default"].createElement(__1.TableCell, tslib_1.__assign({ className: classnames_1["default"]((_b = {},
            _b[classes.container] = true,
            _b[classes.hoverContainer] = draggingColumnId === null,
            _b[classes.dragContainer] = draggingColumnId === columnId,
            _b[className] = true,
            _b)), ref: cellRef, style: tslib_1.__assign({ minWidth: width, maxWidth: width }, style) }, restProps),
        react_1["default"].createElement("div", { className: classes.content }, children),
        react_1["default"].createElement("div", { "aria-hidden": "true", className: classnames_1["default"]((_c = {},
                _c[classes.draggableContainer] = true,
                _c[classes.draggableContainerActive] = draggingColumnId === columnId,
                _c)), onMouseDown: onMouseDown, style: draggableStyle },
            react_1["default"].createElement("div", { className: classes.arrowLeft }),
            react_1["default"].createElement("div", { className: classes.bar }),
            react_1["default"].createElement("div", { className: classes.arrowRight }))));
};
exports.ResizeTableCell = ResizeTableCell;
//# sourceMappingURL=ResizeTableCell.js.map